export default __webpack_public_path__ + "03ba209934c87a1d9c4eaa35d85347fc.png";